export default __webpack_public_path__ + "static/media/goopter-popular-use-case-dining-automation.fd317e6e.jpg";